var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewFlightMarkerDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 37,
    viewBox: "0 0 34 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_244_18",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 0H0V37H34V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_244_18)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_244_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.044 0.5C10.4784 0.5 10.8597 0.7037 11.0967 1.0469H11.0986L19.1953 11.4912H24.5977C25.5004 11.4913 26.7037 11.7572 27.6914 12.2344C28.1873 12.474 28.6559 12.7797 29.0068 13.1563C29.3605 13.5358 29.6152 14.012 29.6152 14.5713C29.6152 15.123 29.3575 15.5939 29.0059 15.9688C28.656 16.3418 28.1884 16.6485 27.6934 16.8906C26.7077 17.3727 25.5038 17.6513 24.5977 17.6514H19.1943L11.0977 28.0518L11.0967 28.0508C10.8889 28.3541 10.5263 28.6426 10.044 28.6426H9.5752C8.7688 28.6426 8.0869 27.8727 8.3457 27.0625L8.3467 27.0586L11.4424 17.6514H4.5762L2.6553 20.2158L2.6504 20.2227L2.6455 20.2285C2.4506 20.4724 2.1332 20.7256 1.6904 20.7256H1.5195C1.3231 20.7256 1.1242 20.6849 0.949201 20.5723C0.770601 20.4572 0.663701 20.2971 0.601601 20.1406C0.493801 19.8693 0.5012 19.5402 0.502 19.3428L0.5 14.5713L0.502 9.7559V9.7354C0.506 9.6354 0.5091 9.5029 0.5195 9.3867C0.5301 9.2689 0.5512 9.1203 0.6104 8.9756C0.674 8.82 0.7839 8.6637 0.9649 8.5547C1.138 8.4505 1.332 8.416 1.5195 8.416H1.6904C2.0705 8.416 2.4051 8.5685 2.6455 8.8692L2.6524 8.877L2.6572 8.8848L4.5791 11.4912H11.4434L8.3467 2.0391L8.3457 2.0361C8.0763 1.1932 8.806 0.5 9.5752 0.5H10.044Z",
    fill: "#666666",
    stroke: "white",
    strokeWidth: 1.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_244_18",
    x: -0.25,
    y: -0.25,
    width: 34.6152,
    height: 33.6426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_244_18"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_244_18",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFlightMarkerDefault);
export default __webpack_public_path__ + "static/media/newFlightMarkerDefault.2a6119a853850ad58eb4ff124609b16d.svg";
export { ForwardRef as ReactComponent };